const SHIP_TOGETHER = 'ShipTogether';
const CONFIGURE_STORE = 'ConfigureStore';
const NEW_PRODUCTS = 'NewProducts';
const AUTOMATION_RULE_ACTION = 'AutomationRuleAction';
const AUTO_SHIP_FBA_ERROR = 'AutoShipFBAError';
const RETURNS_IMPORT = 'ReturnsImport';
const ORDER_REJECTED = 'OrderRejected';
const MERGE_CUSTOMER = 'MergeCustomer';
const INVENTORY_THRESHOLD_WARNING = 'InventoryThresholdWarning';
const LOCAL_DELIVERY_EXCEPTION = 'LocalDeliveryException';
const UNDETERMINED = 'Undetermined';
const GLOBAL = 'Global';
const ORDERS_DEALLOCATED = 'OrdersDeallocated';
const REJECTED_FULFILLMENT = 'RejectedFulfillment';

export const AlertType = {
  SHIP_TOGETHER,
  CONFIGURE_STORE,
  NEW_PRODUCTS,
  AUTOMATION_RULE_ACTION,
  AUTO_SHIP_FBA_ERROR,
  RETURNS_IMPORT,
  ORDER_REJECTED,
  MERGE_CUSTOMER,
  INVENTORY_THRESHOLD_WARNING,
  LOCAL_DELIVERY_EXCEPTION,
  UNDETERMINED,
  GLOBAL,
  ORDERS_DEALLOCATED,
  REJECTED_FULFILLMENT,
};

export const ALERT_TYPES_MIGRATED_TO_NOTIFICATION_HUB = [
  AlertType.SHIP_TOGETHER, // NotificationType.ORDER_ALERT_COMBINE_ORDERS
  AlertType.NEW_PRODUCTS, // NotificationType.ORDER_ALERT_NEW_PRODUCTS
  AlertType.AUTOMATION_RULE_ACTION, // NotificationType.ORDER_ALERT_AUTOMATION_RULE
  AlertType.INVENTORY_THRESHOLD_WARNING, // NotificationType.ORDER_ALERT_LOW_INVENTORY
  AlertType.ORDERS_DEALLOCATED, // NotificationType.ORDER_ALERT_ORDERS_DEALLOCATED
  AlertType.CONFIGURE_STORE, // NotificationType.ORDER_ALERT_CONFIGURE_STORE
  AlertType.LOCAL_DELIVERY_EXCEPTION, // NotificationType.ORDER_ALERT_LOCAL_DELIVERY_EXCEPTION
  AlertType.REJECTED_FULFILLMENT, // NotificationType.ORDER_ALERT_REJECTED_FULFILLMENT
];
